import intl from 'react-intl-universal';
import style from './index.less';
import { Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface Props {
    errorText?: string; //报错文案
    onRefresh: () => void;
}

const ErrorPrompt: React.FC<Props> = (props) => {
    const { errorText, onRefresh } = props;
    return (
        <div className={style.errorContainer}>
            <div style={{ color: 'red' }}>
                <ExclamationCircleOutlined style={{ marginRight: 5 }} />
                {errorText || intl.get('接口异常请重试')}
            </div>
            <Button
                type="link"
                onClick={() => onRefresh()}
            >
                {intl.get('刷新组件')}
            </Button>
        </div>
    );
};

export default ErrorPrompt;
